import type { ExplorationVolume } from '../types/exploration';

/** Ensures each volume carries the display account name for group-by-account views. */
export function stampVolumeAccountNames(
  volumes: ExplorationVolume[],
  nameMap: Record<string, string>
): ExplorationVolume[] {
  return volumes.map((v) => {
    if (!v.accountId) return v;
    const accountName = nameMap[v.accountId] || v.accountName || v.accountId;
    if (accountName === v.accountName) return v;
    return { ...v, accountName };
  });
}
